import { render, staticRenderFns } from "./MasterAiAdviceCreate.vue?vue&type=template&id=2e089ae2&"
import script from "./MasterAiAdviceCreate.vue?vue&type=script&lang=ts&"
export * from "./MasterAiAdviceCreate.vue?vue&type=script&lang=ts&"
import style0 from "./MasterAiAdviceCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports